// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.discounted-price-module__prices___svByj {
  vertical-align: middle;
  width: calc(100% - 125px);
}

.discounted-price-module__discounted-price___gLsqN,
.discounted-price-module__price___A1Rv6 {
  font-weight: 600;
  font-size: 1.25rem;
  display: inline-block;
}

.discounted-price-module__discounted-price___gLsqN {
  color: var(--green600, #2b8000);
  margin-right: 5px;
}

.discounted-price-module__price___A1Rv6 {
  color: var(--neutral60, #686e71);
  text-decoration: line-through;
}

.discounted-price-module__vat___DCs70 {
  font-size: 0.875rem;
  color: var(--neutral75, #424547);
}`, "",{"version":3,"sources":["data:;charset=utf-8,/**%20function%20to%20get%20dimensions%0A%20%20usage%20example%20to%20get%20%60tablet%60%20value%20from%20%60$page-max-widths%60%0A%20%20.class%20%7B%0A%20%20%20%20max-width:%20dim($page-max-widths,%20tablet);%0A%20%20%7D%0A%0A%20*/%0A%0A@use%20'sass:map';%0A%0A@function%20dim($prop,%20$key)%20%7B%0A%20%20@return%20map.get($prop,%20$key);%0A%7D%0A","webpack://./client/app/pages/gift-cards/shared/discounted-price.module.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE,sBAAA;EACA,yBAAA;AAMF;;AAHA;;EAEE,gBAAA;EACA,kBAAA;EACA,qBAAA;AAMF;;AAHA;EACE,+BAAA;EACA,iBAAA;AAMF;;AAHA;EACE,gCAAA;EACA,6BAAA;AAMF;;AAHA;EACE,mBAAA;EACA,gCAAA;AAMF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"prices": `discounted-price-module__prices___svByj`,
	"discounted-price": `discounted-price-module__discounted-price___gLsqN`,
	"price": `discounted-price-module__price___A1Rv6`,
	"vat": `discounted-price-module__vat___DCs70`
};
export default ___CSS_LOADER_EXPORT___;
